import { useEffect } from "react";
import { Camera, ShieldCheck, Zap } from "lucide-react";
import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import ReportNewsForm from "@/components/ReportNewsForm";
import ShareReportLink from "@/components/ShareReportLink";

const TIPS = [
  { icon: Zap, title: "Rápido", text: "Solo describe qué pasa y envía. Nombre y teléfono son opcionales." },
  { icon: Camera, title: "Con evidencia", text: "Adjunta hasta 5 fotos y un video de máximo 50MB." },
  { icon: ShieldCheck, title: "Revisado", text: "Nuestro equipo verifica cada reporte antes de publicarlo." },
];

export default function ReportarNoticiaPage() {
  useEffect(() => {
    document.title = "Reporta una Noticia | Choluteca.net";
  }, []);

  return (
    <Layout>
      <PageHero
        section="compartir"
        title="Reporta una Noticia"
        subtitle="¿Viste algo que la gente de Choluteca debería saber? Cuéntanos, adjunta tus fotos o video y lo revisamos de inmediato."
        badge="Periodismo ciudadano"
        badgeIcon={Camera}
      />

      <div className="container mx-auto px-4 py-12" data-testid="reportar-noticia-page">
        <div className="grid gap-10 lg:grid-cols-[1fr_360px]">
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="mb-1 text-lg font-bold text-brand-text">Cuéntanos qué está pasando</h2>
              <p className="mb-6 text-sm text-brand-textSecondary">
                Los campos marcados con * son obligatorios.
              </p>
              <ReportNewsForm />
            </div>
          </div>

          <aside className="order-1 space-y-4 lg:order-2">
            <ShareReportLink />

            {TIPS.map(({ icon: Icon, title, text }) => (
              <div
                key={title}
                className="flex gap-3 rounded-xl border border-gray-200 bg-white p-4 transition-shadow hover:shadow-md"
              >
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50">
                  <Icon className="h-5 w-5 text-red-600" />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-brand-text">{title}</h3>
                  <p className="text-sm text-brand-textSecondary">{text}</p>
                </div>
              </div>
            ))}
          </aside>
        </div>
      </div>
    </Layout>
  );
}
